export default {
  // 获取验证码
  smsCaptcha: '/sms/captcha',

  // 区域信息
  regionList: '/region/list',

  // 课程类型
  courseCategoryList: '/course_category/list',
  courseCategoryTree: '/course_category/tree',
  // 课程标签
  courseSignatureList: '/course_signature/list',
}